var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideosWatched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27,
    r: 26,
    fill: "#5F6F7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8053 25.6605L24.6847 17.7148C23.2216 16.7557 21.2786 17.8053 21.2786 19.5547L21.2786 35.4461C21.2786 37.1956 23.2216 38.2452 24.6847 37.286L36.8053 29.3403C38.1304 28.4716 38.1304 26.5292 36.8053 25.6605Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosWatched);
export default __webpack_public_path__ + "static/media/VideosWatched.f4243147a49c5d0d098201d153c578b1.svg";
export { ForwardRef as ReactComponent };